// extracted by mini-css-extract-plugin
module.exports = {"root":"SidebarRecordInfo_root"};